import {DomainObject, oneOf} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';

class BalanceAdjustmentPolicy extends DomainObject {
  id;
  type;
  parameter;
  limitDays;

  _relations = {
    type: oneOf([
      'AnnualResetPolicy',
      'BalanceLimitPolicy',
      'CarryoverPolicy',
      'NoLimitPolicy'
    ])
  };


  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      type: observable,
      parameter: observable,
      limitDays: observable,
      localizationTitle: computed,
      localizationDetail: computed
    });


    this.merge(other);
  }


  get localizationTitle() {
    switch (this.type) {
      case 'AnnualResetPolicy':
      case 'BalanceLimitPolicy':
      case 'NoLimitPolicy':
        return `models.time_off.balance_adjustment_policy.type.${this.type}.TITLE`;
      case 'CarryoverPolicy': {
        const limit = this.limitDays ? 'deadline' : 'no_deadline';
        return `models.time_off.balance_adjustment_policy.type.${this.type}.${limit}.TITLE`;
      }
      default:
        throw new Error(`Unsupported type of ${this.type}.`);
    }
  }

  get localizationDetail() {
    switch (this.type) {
      case 'AnnualResetPolicy':
      case 'BalanceLimitPolicy':
      case 'NoLimitPolicy':
        return `models.time_off.balance_adjustment_policy.type.${this.type}.DETAILS`;
      case 'CarryoverPolicy': {
        const limit = this.limitDays ? 'deadline' : 'no_deadline';
        return `models.time_off.balance_adjustment_policy.type.${this.type}.${limit}.DETAILS`;
      }
      default:
        throw new Error(`Unsupported type of ${this.type}.`);
    }
  }
}

export default BalanceAdjustmentPolicy;
